import { motion } from "framer-motion";

const steps = [
  { step: "01", title: "Source", text: "Direct procurement from OEM-grade manufacturing facilities in India — no middle-channel substitutions." },
  { step: "02", title: "Inspect", text: "Inbound batch inspection on dimension, friction grade and lining bond integrity before stock receipt." },
  { step: "03", title: "Document", text: "Each lot tagged with traceable batch numbers, OEM specification reference and customs documentation." },
  { step: "04", title: "Distribute", text: "Local UK warehousing for short-lead-time dispatch. Bulk-fleet orders prioritised on dedicated lanes." },
  { step: "05", title: "Stand By It", text: "Warranty-backed returns process. Fitment guidance and after-sales technical support on every order." },
];

export default function QualityAssurance() {
  return (
    <section
      id="quality"
      data-testid="quality-section"
      className="relative py-24 md:py-32 bg-[#D6E2F0]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="col-span-12 lg:col-span-5">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1770656505727-45268ba7200a?crop=entropy&cs=srgb&fm=jpg&w=1000&q=80"
                alt="Quality inspection close-up"
                className="w-full h-[560px] object-cover border border-[#D5DEE8]"
              />
              <div className="absolute top-6 left-6 bg-white border border-[#D5DEE8] px-5 py-3 shadow-sm">
                <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B8860B]">QC · Live</div>
                <div className="font-serif-display text-[#0F1E33] text-lg mt-1">Pass · Lot Verified</div>
              </div>
              <div className="absolute -bottom-px -right-px bg-[#1E3A5F] text-[#D6E2F0] px-6 py-4">
                <div className="font-mono text-[10px] uppercase tracking-[0.3em]">Process</div>
                <div className="font-serif-display text-2xl">5 Stages · 1 Promise</div>
              </div>
            </div>
          </div>

          <div className="col-span-12 lg:col-span-7">
            <p className="overline-maroon mb-5">04 — Quality Assurance</p>
            <h2 className="font-serif-display font-light text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight text-[#0F1E33] mb-8">
              Quality is a <span className="italic text-[#1E3A5F]">chain</span>,<br />
              not a slogan.
            </h2>
            <div className="hairline-gold w-24 mb-8" />

            <div className="relative pl-8 border-l border-[#D5DEE8]">
              {steps.map((s, i) => (
                <motion.div
                  key={s.step}
                  data-testid={`quality-step-${s.step}`}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="relative pb-10 last:pb-0"
                >
                  <span className="absolute -left-[33px] top-1 w-3 h-3 bg-[#B8860B] outline outline-4 outline-[#D6E2F0]" />
                  <div className="flex items-baseline gap-4 mb-2">
                    <span className="font-mono text-xs tracking-[0.3em] uppercase text-[#B8860B]">{s.step}</span>
                    <span className="font-serif-display text-2xl md:text-3xl text-[#0F1E33] tracking-tight">
                      {s.title}
                    </span>
                  </div>
                  <p className="text-[#4A5A70] leading-relaxed text-sm md:text-base max-w-xl">{s.text}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
